import React from 'react';
import * as Styles from '../../footer-pattern.styled';
import { Link } from '@at/design-system-elements';
export var FooterNavCompany = function (_a) {
    var trackingCallback = _a.trackingCallback;
    return (React.createElement(React.Fragment, null,
        React.createElement(Styles.FooterMetaInfo, { as: "section" },
            React.createElement("span", null,
                "Copyright \u00A9 Auto Trader Limited ",
                new Date().getFullYear(),
                "."),
            React.createElement("span", null, "Auto Trader Limited (trading as Autotrader) is authorised and regulated by the Financial Conduct Authority. Our FCA firm reference number is 735711."),
            React.createElement("span", null, "Autotrader is a credit broker and not a lender. The representative finance examples on this page are designed to give an example of how a finance agreement could look for this vehicle. Finance is subject to status (for example, your income, employment and credit history). Terms and conditions apply. Available to 18s and over. UK residents only. You may need a guarantor or joint hirer."),
            React.createElement("span", null,
                "Autotrader works with commercial partners to advertise motor finance, leasing and insurance. Autotrader typically receives a fee or commissions for these services, however these arrangements vary. You can",
                ' ',
                React.createElement(Link, { routerLink: false, href: "https://help.autotrader.co.uk/hc/en-gb/articles/16865586061725-How-does-Auto-Trader-make-money-from-Finance", trackingCallback: trackingCallback }, "read more about how commissions work"),
                ' ',
                "if you need more information.")),
        React.createElement(Styles.FooterMetaInfo, { as: "section" },
            React.createElement("span", null, "Registered office and headquarters"),
            React.createElement("address", null,
                "4th Floor ",
                React.createElement("br", null),
                "1 Tony Wilson Place",
                React.createElement("br", null),
                "Manchester",
                React.createElement("br", null),
                "M15 4FN",
                React.createElement("br", null),
                "United Kingdom",
                React.createElement("br", null),
                "Registered number: 03909628"))));
};
